import { SxcApp } from '@2sic.com/sxc-angular';
import { httpResource } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ForgotPasswordFormValue } from '../auth/forgot-password/forgot-password';
import { GetToken, LoginFormValue } from '../auth/login/login';
import { ResetPasswordFormValue } from '../auth/reset-password/reset-password.component';
import { UserListImpersonationData } from '../impersonation/impersonation.component';
import { ChangePasswordFormValue } from '../my-profile/change-password/change-password.component';

@Injectable({
  providedIn: 'root',
})
export class AuthApiService {
  constructor(private app: SxcApp) {}

  loginApiCall(loginValue: LoginFormValue): Observable<GetToken> {
    return this.app.api('Login').post<GetToken>(
      'GetToken',
      {}, // <- urlParams,
      loginValue as unknown as GetToken, // Bug 2sxc Post Api Body and Request same Type
    );
  }

  forgotPassword(forgotPasswordFormValue: ForgotPasswordFormValue) {
    return this.app.api('Login').post<ForgotPasswordFormValue>(
      'ForgotPassword',
      {}, // <- urlParams,
      forgotPasswordFormValue, // <- body
    );
  }

  resetPassword(resetPasswordValue: ResetPasswordFormValue) {
    return this.app.api('Login').post<any>(
      'ResetPassword',
      {}, // <- urlParams,
      resetPasswordValue, // <- body
    );
  }

  changePassword(changePasswordValue: ChangePasswordFormValue) {
    return this.app.api('Login').post<any>(
      'ChangePassword',
      {}, // <- urlParams,
      changePasswordValue, // <- body
    );
  }

  getAllUsersImpersonateAs() {
    return httpResource<UserListImpersonationData[]>(() => ({
      url: this.app.api('Login').url('GetAllUsers'),
      method: 'GET',
      body: {},
    })).value;
  }

  impersonateAsApiCall(userName: string) {
    return this.app.api('Login').post<GetToken>(
      'ImpersonateAs',
      {}, // <- urlParams,
      { userName } as unknown as GetToken, // Bug 2sxc Post Api Body and Request same Type
    );
  }
}
